import { BrowserRouter, Routes, Route } from 'react-router-dom';
import NavBar from "./components/NavBar.component";
// import Sidebar from "./components/Sidebar";

import { UserProvider } from "./contexts/user.context";
// import Analytics from "./pages/Analytics.page";
//import CreateExpense from "./pages/CreateExpense.page";
// import EditExpense from "./pages/EditExpense.page";
//import AccountDetailsForm from "./pages/careManagerDetails";
import Login from "./pages/Login.page";
import PrivateRoute from "./pages/PrivateRoute.page";
import Signup from "./pages/Signup.page";
import HealthReports from "./pages/HealthReports";
// import HealthReports from "./pages/HealthReports.page";
// import HealthDetails from "./pages/HealthDetails";
import CareManagerDetailsForm from "./pages/CareManagerDetails";
import PatientPersonalDetailsForm from "./pages/PatientPersonalDetailsForm";
// import InteractiveCard from "./pages/check";
import ConsentForm from "./pages/ConsentForm";
import UploadReports from "./pages/UploadReports.page";
import Symptoms from "./pages/Symptoms";
import ModuleSummary from "./pages/ModuleSummary";
import ComingSoon from "./pages/ComingSoon";
import FileUpload from "./pages/FileUpload";
import AddLovedOnes from "./pages/AddLovedOnes";
import BloodPressure from "./pages/BloodPressure";
import PulseRate from "./pages/PulseRate";
import PatientModuleSummary from "./pages/PatientModuleSummary";
import HealthVaultReportUpload from "./pages/HealthVaultReportUpload";
import OxygenSaturation from "./pages/OxygenSaturation";
import BloodSugar from "./pages/BloodSugar";
import Temperature from "./pages/Temperature";
import BreathingRate from "./pages/BreathingRate";
import AddCareRingMembers from "./pages/AddCareRingMembers";
import AddLocalCarerInfo from "./pages/AddLocalCarerInfo";
// import CarouselSlider from "./pages/CarouselSlider";
// import GoogleFit from "./ComingSoon";

import Role from "./pages/Role";

import "./i18n/i18n";
import SetupCareRing from "./pages/SetupCareRing";
import ModuleSummaryTwo from "./pages/ModuleSummary2";
import ModuleSummaryThree from "./pages/ModuleSummary3";
import ModuleSummaryOne from "./pages/ModuleSummary1";
import DailyCheckIn from "./pages/DailyCheckIn";
import VitalsSummary from "./pages/VitalsSummary";
import VitalsGraph from "./pages/VitalsGraph";
import VitalsGuage from "./pages/VitalsGuage";
import UserFeedbackForm from "./pages/UserFeedbackForm";
import DailyCheckInSummary from "./pages/DailyCheckInSummary";
// import FixedHeader from "./components/FixedHeader";
import Vitals from "./pages/Vitals";
import CareRingsConsent from "./pages/CareRingsConsent";
import LocalCareGiversConsent from "./pages/LocalCareGiversConsent";
import FamilyMembersConsent from "./pages/FamilyMembersConsent";
import AddFamilyMemberInfo from "./pages/AddFamilyMemberInfo";
import TestMenu from "./pages/TestMenu";

import Cough from "./pages/Cough";
import RunnyNose from "./pages/RunnyNose";
import Urine from "./pages/Urine";
// "homepage": "https://globalmedics.ai/webappgm2910",
function App() {
  return (
       <BrowserRouter basename={'/webappgm101122'}>
        {/* <BrowserRouter> */}
       <UserProvider>
        <NavBar />
         <Routes basename={'/webappgm101122'}>
          {/* <Routes> */}
          <Route exact path="/" element={<Login />} />
          <Route exact path="/signup" element={<Signup />} />
          <Route element={<PrivateRoute />}>
            <Route
              exact
              path="/careManagerDetails"
              element={<CareManagerDetailsForm />}
            />
            <Route exact path="/healthReports" element={<HealthReports />} />
            <Route
              exact
              path="/patientPersonalDetailsForm"
              element={<PatientPersonalDetailsForm />}
            />
            {/* <Route exact path="/check" element={<InteractiveCard />} /> */}
            <Route exact path="/consentForm" element={<ConsentForm />} />
            <Route exact path="/symptoms" element={<Symptoms />} />
            <Route exact path="/uploadReports" element={<UploadReports />} />
            <Route exact path="/moduleSummary" element={<ModuleSummary />} />
            <Route
              exact
              path="/moduleSummaryOne"
              element={<ModuleSummaryOne />}
            />
            <Route
              exact
              path="/moduleSummaryTwo"
              element={<ModuleSummaryTwo />}
            />
            <Route
              exact
              path="/moduleSummaryThree"
              element={<ModuleSummaryThree />}
            />
            <Route exact path="/comingSoon" element={<ComingSoon />} />
            <Route exact path="/fileUpload" element={<FileUpload />} />
            <Route exact path="/addLovedOnes" element={<AddLovedOnes />} />
            <Route exact path="/role" element={<Role />} />
            <Route exact path="/bloodPressure" element={<BloodPressure />} />
            <Route exact path="/pulseRate" element={<PulseRate />} />
            <Route
              exact
              path="/patientModuleSummary"
              element={<PatientModuleSummary />}
            />
            <Route
              exact
              path="/healthVaultReportUpload"
              element={<HealthVaultReportUpload />}
            />
            <Route exact path="/setupCareRing" element={<SetupCareRing />} />
            <Route exact path="/dailyCheckIn" element={<DailyCheckIn />} />
            <Route exact path="/vitalsSummary" element={<VitalsSummary />} />
            <Route exact path="/vitalsGraph" element={<VitalsGraph />} />
            <Route exact path="/vitalsGuage" element={<VitalsGuage />} />
            <Route
              exact
              path="/userFeedbackForm"
              element={<UserFeedbackForm />}
            />
            <Route
              exact
              path="/dailyCheckInSummary"
              element={<DailyCheckInSummary />}
            />
            <Route
              exact
              path="/oxygenSaturation"
              element={<OxygenSaturation />}
            />
            <Route exact path="/bloodSugar" element={<BloodSugar />} />
            <Route exact path="/temperature" element={<Temperature />} />
            <Route exact path="/breathingRate" element={<BreathingRate />} />
            <Route exact path="/vitals" element={<Vitals />} />
            <Route
              exact
              path="/addCareRingMembers"
              element={<AddCareRingMembers />}
            />
            <Route
              exact
              path="/careRingsConsent"
              element={<CareRingsConsent />}
            />
            <Route
              exact
              path="/localCareGiversConsent"
              element={<LocalCareGiversConsent />}
            />
            <Route
              exact
              path="/addLocalCarerInfo"
              element={<AddLocalCarerInfo />}
            />
            <Route
              exact
              path="/familyMembersConsent"
              element={<FamilyMembersConsent />}
            />
            <Route
              exact
              path="/addFamilyMemberInfo"
              element={<AddFamilyMemberInfo />}
            />
            <Route exact path="/testMenu" element={<TestMenu />} />
            <Route exact path="/cough" element={<Cough />} />
            <Route exact path="/runnyNose" element={<RunnyNose />} />
            <Route exact path="/urine" element={<Urine />} />
          </Route>
        </Routes>
        </UserProvider>
    </BrowserRouter>
  );
}

export default App;
